import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import styles from './TagWithRemove.module.scss';
const TagWithRemove = ({ children, onRemove }) => {
    return (_jsxs("div", Object.assign({ className: styles.container }, { children: [children, _jsx(Icon, { type: 'close', width: 14, height: 14, className: styles.close, onClick: onRemove })] })));
};
export default TagWithRemove;
